module.exports = __webpack_public_path__ + "img/research-center.6f9f78e1.webp";